module.exports = __webpack_public_path__ + "img/1.80846372.jpg";